import tryConvertToNumber from 'utils/number/tryConvertToNumber';
import moment from 'moment';

/**
 * wraps converter to work with array
 * in addition `in` converter converts data to Array if it is not Array
 * @param converters
 * @returns {{in(*): *, out(*): *}}
 */
export function converterArrayWrapper (converters) {
  return {
    in (i) {
      let data = i;
      if (!Array.isArray(i)) {
        data = [i];
      }
      return data.map(converters.in);
    },
    out (i) {
      return i.map(converters.out);
    }
  };
}

export const dateConverters = {
  in (i) {
    return moment(i).toDate();
  },
  out (i) {
    if (!i) {
      return null;
    }
    return moment(i).format('YYYY-MM-DD');
  }
};

export const sortingConverters = {

  /**
   * @param i f.e `-clicks`
   * @returns {{name: *, direction: *}} with current example will return `{name: 'clicks', direction: 'desc'}`
   */
  in (i) {
    let field = i;

    // if first symbol is `-` than direction is `desc`
    const direction = i[0] === '-' ? 'desc' : 'asc';
    if (direction === 'desc') {
      field = field.substr(1);
    }
    return {
      direction,
      name: field
    };
  },

  /**
   * @param i {{name: *, direction: * }}
   * @returns {string} f.e. `-clicks`
   */
  out (i) {
    if (!i) {
      return '';
    }
    const sign = i.direction === 'asc' ? '' : '-';
    return `${sign}${i.name}`;
  }
};

export const numberConverters = {
  in: tryConvertToNumber,
  out: i => i
};

export const booleanConverters = {
  in (i) {
    if (i === 'true') {
      return true;
    } else if (i === 'false') {
      return false;
    }
    return null;
  },
  out: i => String(i)
};
